export interface IPipeline<InputType, OutputType> {
	run(input: InputType): OutputType;
}
